import React from 'react'
import { useState } from 'react'
import { useLocation } from 'react-router'
import me from '../assets/images/me.png'

export default function Messanger() {

    const [bot, setBot] = useState([
        "Hi! I’m Badr's Bot 🤖",
        "I’m just like Badr, but a far better conversationalist 😉",
        "How can I help you today?"
    ])
    const [options, setOptions] = useState([
        ["👾 I just wanted your Linkedin ", "🔗 Linkedin","https://www.linkedin.com/in/badreddine-ibril-6554b9236/", false],
        ["💀 I just wanted your Email", "📩 badreddineibril@gmail.com","mailto: badreddineibril@gmail.com", false],
        ["👽 I just wanted your Number ", "🔗 Whatsapp","https://api.whatsapp.com/send?phone=212630195980", false],
        ["🎃 I just wanted your Instagram ", "🔗 badr_ibril","https://www.instagram.com/badr_ibril/", false]
    ])
    const [scrolli, setScrolli] = useState(200)
    const [openMsg, setOpenMsg] = useState(false)

    function createNewBot(text,user,action) {
        let chat = document.querySelector('.chat')
        let newBot =  document.createElement('div'); 
        newBot.className = 'bot new';
        newBot.innerHTML = `<a href=${action} target='_blank'>${user}</a>`;
        let newUser =  document.createElement('div'); 
        newUser.className = 'user new';
        newUser.innerHTML = `<p>${text}</p>`;
        chat.appendChild(newUser);
        setTimeout(() => {
            chat.appendChild(newBot);
            chat.scroll({top:scrolli})
            setScrolli(scrolli+200)
        }, 500);
        chat.scroll({top:scrolli})
        setScrolli(scrolli+200)
    }

  return (
    <div className='messanger' style={{visibility : useLocation().pathname == '/' ? 'visible' : 'hidden'}}>
        <button className='msg-btn' onClick={()=>{ setOpenMsg(!openMsg) }} style={{display : openMsg ? 'none' : 'block'}}>
            <span class="material-symbols-outlined">mode_comment</span>
        </button>
        <div className={openMsg ? 'msg-feed pop' : 'msg-feed'} >
            <div className="top">
                <div className="left">
                    <img src={me} />
                    <div>
                        <p>Badr Bot</p>
                        <p className='name'>Ask me a question!</p>
                    </div>
                </div>
                <button onClick={()=>{ setOpenMsg(!openMsg) }} >
                    <span class="material-symbols-outlined">close</span>
                </button>
            </div>
            <div className="chat">
                <div className="bot">
                    {
                        bot.map(item=>{
                            return <p>{item}</p>
                        })
                    }
                </div>
                <div className="options">
                    {
                        options.map(item=>{
                            return <p onClick={()=>{
                                createNewBot(item[0],item[1],item[2])
                            }}>{item[0]}</p>
                        })
                    }
                </div>    
                
            </div>
        </div>
    </div>
  )
}
